import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { changeLocale } from '../../actions/LocaleChangeAction';
import LinkItem from './LinkItem';
import { FormattedMessage } from 'react-intl';

class MobileNav extends Component {
  state = {
    showNav: false,
    showLanguages: false,
  };

  changeLanguage = (e) => {
    this.setState({
      showLanguages: false,
      showNav: false,
    });

    this.props.changeLocale({
      locale: e.currentTarget.dataset.id,
      selectedLanguage: e.currentTarget.innerHTML,
    });
  };

  render() {
    const { showNav, showLanguages } = this.state;
    return (
      <React.Fragment>
        <a
          className={showNav ? 'mobile-toggle opened' : 'mobile-toggle'}
          style={{ cursor: 'pointer' }}
          onClick={() =>
            this.setState({
              showNav: !this.state.showNav,
            })
          }
        >
          <span className="open">
            <i className="fa fa-bars" aria-hidden="true"></i>
          </span>
          <span
            className="close"
            style={{ cursor: 'pointer' }}
            onClick={() =>
              this.setState({
                showNav: !this.state.showNav,
              })
            }
          >
            &times;
          </span>
        </a>

        <nav
          className="mobile"
          style={showNav ? { display: 'block' } : { display: 'none' }}
        >
          <div className="container-fluid">
            <div className="row">
              <div className="col-sm-6">
                <ul className="accordion-list">
                  <li>
                    <Link to="/" className="padding-none">
                      <strong className="label">
                        <FormattedMessage
                          id="regulatory.breadcrumb.title"
                          defaultMessage="BD Regulatory"
                        />
                      </strong>
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/qcinfo"
                      onClick={() =>
                        this.setState({
                          showNav: !this.state.showNav,
                        })
                      }
                    >
                      <FormattedMessage
                        id="qc.title"
                        defaultMessage="Quality Certificates"
                      />
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/positionstatement"
                      onClick={() =>
                        this.setState({
                          showNav: !this.state.showNav,
                        })
                      }
                    >
                      <FormattedMessage
                        id="pos.title"
                        defaultMessage="Position Statements"
                      />
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/sdsInfo"
                      onClick={() =>
                        this.setState({
                          showNav: !this.state.showNav,
                        })
                      }
                    >
                      <FormattedMessage
                        id="sds.title"
                        defaultMessage="SDS/SVHC/Article Statement"
                      />
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/resources"
                      onClick={() =>
                        this.setState({
                          showNav: !this.state.showNav,
                        })
                      }
                    >
                      <FormattedMessage
                        id="resources.title"
                        defaultMessage="Resources"
                      />
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/faqs"
                      onClick={() =>
                        this.setState({
                          showNav: !this.state.showNav,
                        })
                      }
                    >
                      <FormattedMessage id="faq.title" defaultMessage="FAQ" />
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/contactus"
                      onClick={() =>
                        this.setState({
                          showNav: !this.state.showNav,
                        })
                      }
                    >
                      <FormattedMessage
                        id="contactus.title"
                        defaultMessage="Contact Us"
                      />
                    </Link>
                  </li>
                </ul>
              </div>
              <div className="col-sm-6">
                <ul className="accordion-list links">
                  <li>
                    <a
                      className={showLanguages ? 'trigger opened' : 'trigger'}
                      style={{ cursor: 'pointer' }}
                      onClick={() =>
                        this.setState({
                          showLanguages: !this.state.showLanguages,
                        })
                      }
                    >
                      {this.props.selectedLanguage}
                    </a>
                    <div
                      className="scroll-language"
                      style={
                        showLanguages
                          ? { display: 'block' }
                          : { display: 'none' }
                      }
                    >
                      <ul>
                        <LinkItem
                          onClick={this.changeLanguage}
                          name="English"
                          dataId="en"
                        />
                        <LinkItem
                          onClick={this.changeLanguage}
                          name="Français"
                          dataId="fr"
                        />
                        <LinkItem
                          onClick={this.changeLanguage}
                          name="Español"
                          dataId="es"
                        />
                        <LinkItem
                          onClick={this.changeLanguage}
                          name="日本語"
                          dataId="ja"
                        />
                        <LinkItem
                          onClick={this.changeLanguage}
                          name="Portuguese"
                          dataId="pt"
                        />
                        <LinkItem
                          onClick={this.changeLanguage}
                          name="Deutsch"
                          dataId="de"
                        />
                        <LinkItem
                          onClick={this.changeLanguage}
                          name="中文"
                          dataId="zh"
                        />
                        <LinkItem
                          onClick={this.changeLanguage}
                          name="한국어"
                          dataId="ko"
                        />
                      </ul>
                    </div>
                  </li>
                  <li>
                    <a href="https://www.bd.com">
                      <i className="fa fa-globe" aria-hidden="true"></i> BD
                      Worldwide
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </nav>
      </React.Fragment>
    );
  }
}

MobileNav.propTypes = {
  changeLocale: PropTypes.func.isRequired,
  locale: PropTypes.string,
  selectedLanguage: PropTypes.string,
};

MobileNav.defaultProps = {
  locale: 'en',
  selectedLanguage: 'English',
};

const mapStateToProps = (state) => {
  return {
    locale: state.localeReducer.locale.locale,
    selectedLanguage: state.localeReducer.locale.selectedLanguage,
  };
};

export default connect(mapStateToProps, { changeLocale })(MobileNav);
